import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "add_portal_drawer",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "add_portal",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'400px', 'md': '500px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#add_portal_drawer_toggle",
  "data-kt-drawer-close": "#add_portal_drawer_close"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Create Processor Connection", -1)
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary",
  id: "add_portal_drawer_close"
}
const _hoisted_6 = { class: "svg-icon fw-bolder svg-icon-2" }
const _hoisted_7 = { class: "modal-body scroll-y m-5" }
const _hoisted_8 = { class: "w-100" }
const _hoisted_9 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Processor Alias", -1)
const _hoisted_11 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Select a Connection and Endpoint", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "d-flex flex-stack pt-15" }
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_19 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs012.svg" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("form", {
          class: "mx-auto mw-600px w-100 py-10",
          novalidate: "novalidate",
          id: "create_portal_form",
          onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit()))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alias_name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.alias_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_cascader, {
                modelValue: _ctx.selectedConnEnd,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedConnEnd) = $event)),
                options: _ctx.connEndOptions,
                onChange: _ctx.selConnEnd,
                props: { expandTrigger: 'hover' }
              }, null, 8, ["modelValue", "options", "onChange"])
            ]),
            (_ctx.parameters)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.parameters), (paramName, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "d-flex flex-column mb-5 fv-row",
                      key: index
                    }, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(paramName), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.parameters[paramName]) = $event)
                      }, null, 8, _hoisted_15), [
                        [_vModelText, _ctx.parameters[paramName]]
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-lg btn-primary",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.formSubmit()), ["prevent"])),
                ref: "submitButton"
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_20
              ], 512)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}